import queryToProps from "./queryToProps";
import propsToQuery from "./propsToQuery";

const apiRoot = "/api";

export { queryToProps, propsToQuery, apiRoot };
